// Maki icons from https://github.com/mapbox/maki
// and https://github.com/mapbox/maki/blob/mb-pages/_includes/maki.json
module.exports = {
  disclaimer: _t('assets.maki-icons.disclaimer'),
  icons: [
    {
      'name': 'Square stroked',
      'icon': 'square-stroked'
    },
    {
      'name': 'Square solid',
      'icon': 'square'
    },
    {
      'name': 'Triangle stroked',
      'icon': 'triangle-stroked'
    },
    {
      'name': 'Triangle solid',
      'icon': 'triangle'
    },
    {
      'name': 'Star stroked',
      'icon': 'star-stroked'
    },
    {
      'name': 'Star solid',
      'icon': 'star'
    },
    {
      'name': 'Cross',
      'icon': 'cross'
    },
    {
      'name': 'Marker Stroke',
      'icon': 'marker-stroked'
    },
    {
      'name': 'Marker Solid',
      'icon': 'marker'
    },
    {
      'name': 'Religious Jewish',
      'icon': 'religious-jewish'
    },
    {
      'name': 'Religious Christian',
      'icon': 'religious-christian'
    },
    {
      'name': 'Religious Muslim',
      'icon': 'religious-muslim'
    },
    {
      'name': 'Cemetery',
      'icon': 'cemetery'
    },
    {
      'name': 'Rocket',
      'icon': 'rocket'
    },
    {
      'name': 'Airport',
      'icon': 'airport'
    },
    {
      'name': 'Heliport',
      'icon': 'heliport'
    },
    {
      'name': 'Rail',
      'icon': 'rail'
    },
    {
      'name': 'Rail Metro',
      'icon': 'rail-metro'
    },
    {
      'name': 'Rail Light',
      'icon': 'rail-light'
    },
    {
      'name': 'Bus',
      'icon': 'bus'
    },
    {
      'name': 'Fuel',
      'icon': 'fuel'
    },
    {
      'name': 'Parking',
      'tags': [
        'parking',
        'transportation'
      ],
      'icon': 'parking'
    },
    {
      'name': 'Parking Garage',
      'tags': [
        'parking',
        'transportation',
        'garage'
      ],
      'icon': 'parking-garage'
    },
    {
      'name': 'Airfield',
      'tags': [
        'airfield',
        'airport',
        'plane',
        'landing strip'
      ],
      'icon': 'airfield'
    },
    {
      'name': 'Roadblock',
      'tags': [
        'roadblock',
        'stop',
        'warning',
        'dead end'
      ],
      'icon': 'roadblock'
    },
    {
      'name': 'Ferry',
      'tags': [
        'ship',
        'boat',
        'water',
        'ferry',
        'transportation'
      ],
      'icon': 'ferry'
    },
    {
      'name': 'Harbor',
      'tags': [
        'marine',
        'dock',
        'water',
        'wharf'
      ],
      'icon': 'harbor'
    },
    {
      'name': 'Bicycle',
      'tags': [
        'cycling',
        'cycle',
        'transportation'
      ],
      'icon': 'bicycle'
    },
    {
      'name': 'Park',
      'tags': [
        'recreation',
        'park',
        'forest',
        'tree',
        'green',
        'woods',
        'nature'
      ],
      'icon': 'park'
    },
    {
      'name': 'Park 2',
      'tags': [
        'recreation',
        'park',
        'forest',
        'tree',
        'green',
        'woods',
        'nature'
      ],
      'icon': 'park2'
    },
    {
      'name': 'Museum',
      'tags': [
        'recreation',
        'museum',
        'tourism'
      ],
      'icon': 'museum'
    },
    {
      'name': 'Lodging',
      'tags': [
        'lodging',
        'hotel',
        'recreation',
        'motel',
        'tourism'
      ],
      'icon': 'lodging'
    },
    {
      'name': 'Monument',
      'tags': [
        'recreation',
        'statue',
        'monument',
        'tourism'
      ],
      'icon': 'monument'
    },
    {
      'name': 'Zoo',
      'tags': [
        'recreation',
        'zoo',
        'animal',
        'giraffe'
      ],
      'icon': 'zoo'
    },
    {
      'name': 'Garden',
      'tags': [
        'recreation',
        'garden',
        'park',
        'flower',
        'nature'
      ],
      'icon': 'garden'
    },
    {
      'name': 'Campsite',
      'tags': [
        'recreation',
        'campsite',
        'camp',
        'camping',
        'tent',
        'nature'
      ],
      'icon': 'campsite'
    },
    {
      'name': 'Theatre',
      'tags': [
        'recreation',
        'theatre',
        'theater',
        'entertainment',
        'play',
        'performance'
      ],
      'icon': 'theatre'
    },
    {
      'name': 'Art gallery',
      'tags': [
        'art',
        'center',
        'museum',
        'gallery',
        'creative',
        'recreation',
        'entertainment',
        'studio'
      ],
      'icon': 'art-gallery'
    },
    {
      'name': 'Pitch',
      'tags': [
        'pitch',
        'track',
        'athletic',
        'sports',
        'field'
      ],
      'icon': 'pitch'
    },
    {
      'name': 'Soccer',
      'tags': [
        'soccer',
        'sports'
      ],
      'icon': 'soccer'
    },
    {
      'name': 'American Football',
      'tags': [
        'football',
        'sports'
      ],
      'icon': 'america-football'
    },
    {
      'name': 'Tennis',
      'tags': [
        'tennis',
        'court',
        'ball',
        'sports'
      ],
      'icon': 'tennis'
    },
    {
      'name': 'Basketball',
      'tags': [
        'basketball',
        'ball',
        'sports'
      ],
      'icon': 'basketball'
    },
    {
      'name': 'Baseball',
      'tags': [
        'baseball',
        'softball',
        'ball',
        'sports'
      ],
      'icon': 'baseball'
    },
    {
      'name': 'Golf',
      'tags': [
        'golf',
        'sports',
        'course'
      ],
      'icon': 'golf'
    },
    {
      'name': 'Swimming',
      'tags': [
        'swimming',
        'water',
        'swim',
        'sports'
      ],
      'icon': 'swimming'
    },
    {
      'name': 'Cricket',
      'tags': [
        'cricket',
        'sports'
      ],
      'icon': 'cricket'
    },
    {
      'name': 'Skiing',
      'tags': [
        'winter',
        'skiing',
        'ski',
        'sports'
      ],
      'icon': 'skiing'
    },
    {
      'name': 'School',
      'tags': [
        'school',
        'highschool',
        'elementary',
        'children',
        'amenity',
        'middle'
      ],
      'icon': 'school'
    },
    {
      'name': 'College',
      'tags': [
        'college',
        'school',
        'amenity',
        'university'
      ],
      'icon': 'college'
    },
    {
      'name': 'Library',
      'tags': [
        'library',
        'books',
        'amenity'
      ],
      'icon': 'library'
    },
    {
      'name': 'Post',
      'tags': [
        'post',
        'office',
        'amenity',
        'mail',
        'letter'
      ],
      'icon': 'post'
    },
    {
      'name': 'Fire station',
      'tags': [
        'fire',
        'station',
        'amenity'
      ],
      'icon': 'fire-station'
    },
    {
      'name': 'Town hall',
      'tags': [
        'townhall',
        'mayor',
        'building',
        'amenity',
        'government'
      ],
      'icon': 'town-hall'
    },
    {
      'name': 'Police',
      'tags': [
        'police',
        'jail',
        'arrest',
        'amenity',
        'station'
      ],
      'icon': 'police'
    },
    {
      'name': 'Prison',
      'tags': [
        'prison',
        'jail',
        'amenity'
      ],
      'icon': 'prison'
    },
    {
      'name': 'Embassy',
      'tags': [
        'embassy',
        'diplomacy',
        'consulate',
        'amenity',
        'flag'
      ],
      'icon': 'embassy'
    },
    {
      'name': 'Beer',
      'tags': [
        'bar',
        'beer',
        'drink',
        'commercial',
        'biergarten',
        'pub'
      ],
      'icon': 'beer'
    },
    {
      'name': 'Restaurant',
      'tags': [
        'restaurant',
        'commercial'
      ],
      'icon': 'restaurant'
    },
    {
      'name': 'Cafe',
      'tags': [
        'cafe',
        'coffee',
        'commercial',
        'tea'
      ],
      'icon': 'cafe'
    },
    {
      'name': 'Shop',
      'tags': [
        'shop',
        'mall',
        'commercial',
        'store'
      ],
      'icon': 'shop'
    },
    {
      'name': 'Fast Food',
      'tags': [
        'food',
        'fast',
        'commercial',
        'burger',
        'drive-through'
      ],
      'icon': 'fast-food'
    },
    {
      'name': 'Bar',
      'tags': [
        'bar',
        'drink',
        'commercial',
        'club',
        'martini',
        'lounge'
      ],
      'icon': 'bar'
    },
    {
      'name': 'Bank',
      'tags': [
        'bank',
        'atm',
        'commercial',
        'money'
      ],
      'icon': 'bank'
    },
    {
      'name': 'Grocery',
      'tags': [
        'food',
        'grocery',
        'commercial',
        'store',
        'market'
      ],
      'icon': 'grocery'
    },
    {
      'name': 'Cinema',
      'tags': [
        'cinema',
        'theatre',
        'film',
        'movie',
        'commercial',
        'theater',
        'entertainment'
      ],
      'icon': 'cinema'
    },
    {
      'name': 'Pharmacy',
      'tags': [
        'pharmacy',
        'drugs',
        'medication',
        'social',
        'medicine',
        'prescription'
      ],
      'icon': 'pharmacy'
    },
    {
      'name': 'Hospital',
      'tags': [
        'hospital',
        'health',
        'medication',
        'social',
        'medicine',
        'medical',
        'clinic'
      ],
      'icon': 'hospital'
    },
    {
      'name': 'Danger',
      'tags': [
        'minefield',
        'landmine',
        'disaster',
        'dangerous',
        'hazard'
      ],
      'icon': 'danger'
    },
    {
      'name': 'Industrial',
      'tags': [
        'industrial',
        'factory',
        'property',
        'building'
      ],
      'icon': 'industrial'
    },
    {
      'name': 'Warehouse',
      'tags': [
        'warehouse',
        'property',
        'storage',
        'building'
      ],
      'icon': 'warehouse'
    },
    {
      'name': 'Commercial',
      'tags': [
        'commercial',
        'property',
        'business',
        'building'
      ],
      'icon': 'commercial'
    },
    {
      'name': 'Building',
      'tags': [
        'building',
        'property',
        'structure',
        'business',
        'building'
      ],
      'icon': 'building'
    },
    {
      'name': 'Place of worship',
      'tags': [
        'religion',
        'ceremony',
        'religious',
        'nondenominational',
        'church',
        'temple'
      ],
      'icon': 'place-of-worship'
    },
    {
      'name': 'Alcohol shop',
      'tags': [
        'alcohol',
        'liquor',
        'store',
        'shop',
        'beer',
        'wine',
        'vodka'
      ],
      'icon': 'alcohol-shop'
    },
    {
      'name': 'Logging',
      'tags': [
        'logger',
        'chainsaw',
        'woods',
        'industry'
      ],
      'icon': 'logging'
    },
    {
      'name': 'Oil well',
      'tags': [
        'oil',
        'natural',
        'environment',
        'industry',
        'resources'
      ],
      'icon': 'oil-well'
    },
    {
      'name': 'Slaughterhouse',
      'tags': [
        'cows',
        'cattle',
        'food',
        'meat',
        'industry',
        'resources'
      ],
      'icon': 'slaughterhouse'
    },
    {
      'name': 'Dam',
      'tags': [
        'water',
        'natural',
        'hydro',
        'hydroelectric',
        'energy',
        'environment',
        'industry',
        'resources'
      ],
      'icon': 'dam'
    },
    {
      'name': 'Water',
      'tags': [
        'water',
        'natural',
        'hydro',
        'lake',
        'river',
        'ocean',
        'resources'
      ],
      'icon': 'water'
    },
    {
      'name': 'Wetland',
      'tags': [
        'water',
        'swamp',
        'natural'
      ],
      'icon': 'wetland'
    },
    {
      'name': 'Disability',
      'tags': [
        'handicap',
        'wheelchair',
        'access'
      ],
      'icon': 'disability'
    },
    {
      'name': 'Telephone',
      'tags': [
        'payphone',
        'call'
      ],
      'icon': 'telephone'
    },
    {
      'name': 'Emergency Telephone',
      'tags': [
        'payphone',
        'danger',
        'safety',
        'call'
      ],
      'icon': 'emergency-telephone'
    },
    {
      'name': 'Toilets',
      'tags': [
        'bathroom',
        'men',
        'women',
        'sink',
        'washroom',
        'lavatory'
      ],
      'icon': 'toilets'
    },
    {
      'name': 'Waste Basket',
      'tags': [
        'trash',
        'rubbish',
        'bin',
        'garbage'
      ],
      'icon': 'waste-basket'
    },
    {
      'name': 'Music',
      'tags': [
        'stage',
        'performance',
        'band',
        'concert',
        'venue'
      ],
      'icon': 'music'
    },
    {
      'name': 'Land Use',
      'tags': [
        'zoning',
        'usage',
        'area'
      ],
      'icon': 'land-use'
    },
    {
      'name': 'City',
      'tags': [
        'area',
        'point',
        'place',
        'urban'
      ],
      'icon': 'city'
    },
    {
      'name': 'Town',
      'tags': [
        'area',
        'point',
        'place',
        'small'
      ],
      'icon': 'town'
    },
    {
      'name': 'Village',
      'tags': [
        'area',
        'point',
        'place',
        'small',
        'rural'
      ],
      'icon': 'village'
    },
    {
      'name': 'Farm',
      'tags': [
        'building',
        'farming',
        'crops',
        'plants',
        'agriculture',
        'rural'
      ],
      'icon': 'farm'
    },
    {
      'name': 'Bakery',
      'tags': [
        'bakery',
        'pastry',
        'croissant',
        'food',
        'shop',
        'bread'
      ],
      'icon': 'bakery'
    },
    {
      'name': 'Dog Park',
      'tags': [
        'dog',
        'pet'
      ],
      'icon': 'dog-park'
    },
    {
      'name': 'Lighthouse',
      'tags': [
        'building',
        'navigation',
        'nautical',
        'ocean',
        'logistics'
      ],
      'icon': 'lighthouse'
    },
    {
      'name': 'Clothing Store',
      'tags': [
        'clothing',
        'store',
        'shop'
      ],
      'icon': 'clothing-store'
    },
    {
      'name': 'Polling Place',
      'icon': 'polling-place'
    },
    {
      'name': 'Playground',
      'icon': 'playground'
    },
    {
      'name': 'Entrance',
      'icon': 'entrance'
    },
    {
      'name': 'Heart',
      'icon': 'heart'
    },
    {
      'name': 'London Underground',
      'icon': 'london-underground'
    },
    {
      'name': 'Minefield',
      'icon': 'minefield'
    },
    {
      'name': 'Rail Underground',
      'icon': 'rail-underground'
    },
    {
      'name': 'Rail Above',
      'icon': 'rail-above'
    },
    {
      'name': 'Camera',
      'icon': 'camera'
    },
    {
      'name': 'Laundry',
      'icon': 'laundry'
    },
    {
      'name': 'Car',
      'icon': 'car'
    },
    {
      'name': 'Suitcase',
      'icon': 'suitcase'
    },
    {
      'name': 'Hairdresser',
      'icon': 'hairdresser'
    },
    {
      'name': 'Chemist',
      'icon': 'chemist'
    },
    {
      'name': 'Mobile phone',
      'icon': 'mobilephone'
    },
    {
      'name': 'Scooter',
      'icon': 'scooter'
    }
  ]
};
